import { Row, Tag } from "antd";
import dayjs from "../../../../configs/dayjs";
import { ClockCircleOutlined } from "@ant-design/icons";
import { useGetDateDiff } from "../../../Account/components/View/User/Details/hooks/useGetDateDiff";
import { useMemo } from "react";

type NextDueDateRowProps = {
  nextDueDate: string;
};

export const NextDueDateRow = ({ nextDueDate }: NextDueDateRowProps) => {
  const { date } = useGetDateDiff({ paymentDate: nextDueDate });

  const postfix: string = useMemo(() => (date.diff !== 1 ? "s" : ""), [date]);

  return (
    <Row className="w-100 align-center mb-1">
      <ClockCircleOutlined className="mr-2 text-md title" />
      <p className="my-0 text-md title mr-2">
        Next due on {dayjs(nextDueDate).format("MMMM D, YYYY")}
      </p>
      <Tag color={date.diff > 0 ? "orange" : ""} className="my-1">
        {date.diff > 0
          ? `${date.diff} day${postfix} late`
          : `in ${Math.abs(date.diff)} day${postfix}`}
      </Tag>
    </Row>
  );
};
